import { render } from "./orders-table.vue?vue&type=template&id=b1a3bab4&scoped=true"
import script from "./orders-table.vue?vue&type=script&lang=ts"
export * from "./orders-table.vue?vue&type=script&lang=ts"

import "./orders-table.vue?vue&type=style&index=0&id=b1a3bab4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1a3bab4"

export default script